/**
 * EnemyAttackParticle.js
 */

import { Game } from "pixi_core";
import { ENEMY_ATTACK_PARTICLE_TRAVEL_TIME, ENEMY_ATTACK_PARTICLE_CURVE_VERTICAL_RANGE } from "../../Constants";
import { EnemyParticle } from "./EnemyParticle";

export class EnemyAttackParticle extends EnemyParticle {
    /**
     * @public
     * @param {Number} startX
     * @param {Number} startY
     * @param {Number} targetX
     * @param {Number} targetY
     * @param {Function} callback
     */
    constructor(startX, startY, targetX, targetY, callback) {
        super(Game.design.getGraphicData("EnemyAttackParticle"), Game.design.getGraphicData("EnemyAttackParticleTrail"), callback);

        const verticalSide = Math.random() > 0.5 ? 1 : -1;

        // First control point at 1/3 of the horizontal distance and random vertical range
        const controlPt1X = startX + ((targetX - startX) * 1) / 3;
        const controlPt1Y = (startY + targetY) / 2 + ENEMY_ATTACK_PARTICLE_CURVE_VERTICAL_RANGE * Math.random() * verticalSide;

        // Second control point at 2/3 of the horizontal distance and random vertical range
        const controlPt2X = startX + ((targetX - startX) * 2) / 3;
        const controlPt2Y = (startY + targetY) / 2 + ENEMY_ATTACK_PARTICLE_CURVE_VERTICAL_RANGE * Math.random() * verticalSide;

        this._setMovementCurve(
            startX,
            startY,
            controlPt1X,
            controlPt1Y,
            controlPt2X,
            controlPt2Y,
            targetX,
            targetY,
            ENEMY_ATTACK_PARTICLE_TRAVEL_TIME
        );
    }
}
